import { Box, Loader, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

export default function PageLoaderFallback() {
  const { t } = useTranslation();
  return (
    <Box mt={50} fw={500} w="max-content" h="100%" mx="auto" fz={25}>
      <Stack align="center">
        {t('keywords.page-loading-please-wait')}
        <Loader type="dots" size={50} />
      </Stack>
    </Box>
  );
}
